'use strict';

var React = require('react');

var SvgFulfillmentFulfilledMajor = function SvgFulfillmentFulfilledMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M11 4h8l-1.845-2.571c-.192-.267-.546-.43-.928-.429h-5.227v3Zm-2-3h-5.227c-.382-.001-.736.162-.928.429l-1.845 2.571h8v-3Zm-8 5v10.5a1.5 1.5 0 0 0 1.5 1.5h6c1 0 1.5-1 1.5-1 0-.534.003-1.067.01-1.5 0-3.584 2.913-6.5 6.495-6.5h1.495s1 0 1-1v-2h-18Zm18.998 6.753a.926.926 0 0 1-.134.544l-3.738 4.46c-.272.324-.68.324-.951 0l-2.04-2.433a.925.925 0 0 1-.133-.544.887.887 0 0 1 .197-.515.637.637 0 0 1 .432-.236.605.605 0 0 1 .456.16l1.563 1.865 3.263-3.892a.605.605 0 0 1 .456-.16.638.638 0 0 1 .432.236.887.887 0 0 1 .197.515Z"
  }));
};

exports.SvgFulfillmentFulfilledMajor = SvgFulfillmentFulfilledMajor;
